var _circle, _path, _rect, _rect2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHubIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FFE5D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10156 9.85986V14.9998H5.9142V10.7335H14.2438V14.9998H15.097V9.85986H5.10156Z",
    fill: "#F09E72"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.70203,
    y: 12.4402,
    width: 2.21445,
    height: 2.2754,
    fill: "#F09E72"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4041,
    y: 12.4402,
    width: 2.21445,
    height: 2.2754,
    fill: "#F09E72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2626 8.34424H6.89613L10.0224 6.57226L13.2626 8.34424Z",
    fill: "#F09E72",
    stroke: "#F09E72"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubIcon);
export default __webpack_public_path__ + "static/media/HubIcon.5f84de96d4d991e34ec7cf494f0de50c.svg";
export { ForwardRef as ReactComponent };